import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-widget',
  templateUrl: './online-widget.component.html',
  styleUrls: ['./online-widget.component.scss']
})
export class OnlineWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
